import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

const CalculatorShell = ({ title, badge = 'Herramienta interactiva', children, disclosureText }) => (
  <Box
    sx={{
      border: '1px solid #E6E9EE',
      borderRadius: '14px',
      bgcolor: '#fff',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      mt: 4,
      mb: '72px',
      overflow: 'hidden',
    }}
  >
    {/* Header strip */}
    <Box
      sx={{
        bgcolor: '#F7F9FC',
        borderBottom: '1px solid #E6E9EE',
        px: { xs: 2.5, md: 4 },
        py: 2,
      }}
    >
      <Typography
        variant="overline"
        sx={{
          fontSize: 12,
          fontWeight: 700,
          color: '#1E3A5F',
          letterSpacing: 1.2,
        }}
      >
        {badge.toUpperCase()}
      </Typography>
      <Typography
        variant="h6"
        sx={{ fontWeight: 600, color: '#1A1A1A', mt: 0.25 }}
      >
        {title}
      </Typography>
    </Box>

    {/* Body */}
    <Box sx={{ px: { xs: 2.5, md: 4 }, py: 3 }}>
      {children}
    </Box>

    {/* Footer disclaimer */}
    <Box sx={{ px: { xs: 2.5, md: 4 }, pb: 2.5, mt: 2 }}>
      <Divider sx={{ mb: 2 }} />
      <Typography
        sx={{
          color: '#5F6B7A',
          fontStyle: 'italic',
          fontSize: 12,
          lineHeight: 1.6,
          letterSpacing: 0.15,
        }}
      >
        {disclosureText ||
          'Esta es una estimación educativa. Consulta un asesor financiero para tu situación específica.'}
      </Typography>
    </Box>
  </Box>
);

export default CalculatorShell;
